function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectListingScore1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 16,
    viewBox: "0 0 38 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.4164 8C22.4164 3.99594 25.6623 0.75 29.6664 0.75C33.6705 0.75 36.9164 3.99594 36.9164 8C36.9164 12.0041 33.6705 15.25 29.6664 15.25C25.6623 15.25 22.4164 12.0041 22.4164 8Z",
    fill: "#D5D6D8",
    stroke: "white",
    style: {
      fill: "#D5D6D8",
      fill: "color(display-p3 0.8353 0.8392 0.8471)",
      fillOpacity: 1,
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0837 8C17.0837 3.99594 20.3297 0.75 24.3337 0.75C28.3378 0.75 31.5837 3.99594 31.5837 8C31.5837 12.0041 28.3378 15.25 24.3337 15.25C20.3297 15.25 17.0837 12.0041 17.0837 8Z",
    fill: "#D5D6D8",
    stroke: "white",
    style: {
      fill: "#D5D6D8",
      fill: "color(display-p3 0.8353 0.8392 0.8471)",
      fillOpacity: 1,
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7511 8C11.7511 3.99594 14.997 0.75 19.0011 0.75C23.0051 0.75 26.2511 3.99594 26.2511 8C26.2511 12.0041 23.0051 15.25 19.0011 15.25C14.997 15.25 11.7511 12.0041 11.7511 8Z",
    fill: "#D5D6D8",
    stroke: "white",
    style: {
      fill: "#D5D6D8",
      fill: "color(display-p3 0.8353 0.8392 0.8471)",
      fillOpacity: 1,
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.41641,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 7.25,
    fill: "#D5D6D8",
    stroke: "white",
    style: {
      fill: "#D5D6D8",
      fill: "color(display-p3 0.8353 0.8392 0.8471)",
      fillOpacity: 1,
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.08374,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 7.25,
    fill: "#78BB96",
    stroke: "white",
    style: {
      fill: "#78BB96",
      fill: "color(display-p3 0.4706 0.7333 0.5873)",
      fillOpacity: 1,
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33374 8L7.33374 10L11.3337 6",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectListingScore1);
export default __webpack_public_path__ + "static/media/project-listing-score-1.244ef7587d0308b86945402c962cfb91.svg";
export { ForwardRef as ReactComponent };